

<section id="content" class="errorSection">
  <div class="container">
      <div class="row">
          <div class="col-12">
            <p>An error has occured. Please refresh and try again. If the problem persists please <a [routerLink]="['/open-account']" fragment="contact-form">contact us.</a></p>
          </div>
  </div>
      </div>
</section>